import { getCurrentFramework } from '../getCurrentFramework.js';
import { getTCData, getCustomVendorConsents } from './api.js';

const defaultConsents = {
  "1": false,
  "2": false,
  "3": false,
  "4": false,
  "5": false,
  "6": false,
  "7": false,
  "8": false,
  "9": false,
  "10": false,
  "11": false
};
const getConsentState = async () => {
  const [tcData, customVendors] = await Promise.all([
    getTCData(),
    getCustomVendorConsents()
  ]);
  if (typeof tcData === "undefined") {
    const currentFramework = getCurrentFramework() ?? "undefined";
    throw new Error(
      `No TC Data found with current framework: ${currentFramework}`
    );
  }
  const consents = {
    ...defaultConsents,
    ...tcData.purpose.consents
  };
  const { eventStatus, gdprApplies, tcString, addtlConsent } = tcData;
  const { grants } = customVendors;
  const vendorConsents = Object.keys(grants).sort().reduce((acc, cur) => ({ ...acc, [cur]: grants[cur]?.vendorGrant }), {});
  return {
    consents,
    eventStatus,
    vendorConsents,
    addtlConsent,
    gdprApplies,
    tcString
  };
};

export { getConsentState };
